'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newsletterSubscribe = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var KEY = '906268c6f6c075e75168af7f8214830e';

/**
 * Subscribe customer to the Newsletter through Emarsys
 *
 * @async
 * @param {Object} requestData - Data needed to handle the request
 * @param {string} requestData.customerEmail - The email of the customer
 * @param {string} requestData.tag - Adds this tag to the customer
 *
 * @returns data - The server response
 */
var newsletterSubscribe = exports.newsletterSubscribe = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
    var customerEmail = _ref2.customerEmail,
        _ref2$tag = _ref2.tag,
        tag = _ref2$tag === undefined ? null : _ref2$tag,
        _ref2$dob = _ref2.dob,
        dob = _ref2$dob === undefined ? null : _ref2$dob;
    var url, params, config, response, data;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = location.origin + '/apps/emarsys_bridge/api/add_dob_to_customer';
            params = {
              key: KEY,
              email: customerEmail,
              shopify_domain: theme.shopifyDomain,
              tag: tag,
              dob: dob
            };
            config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: (0, _stringify2.default)(params)
            };
            _context.next = 5;
            return fetch(url, config);

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            data = _context.sent;
            return _context.abrupt('return', data);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function newsletterSubscribe(_x) {
    return _ref.apply(this, arguments);
  };
}();